var chunkMapping = {
	"842": [
		5427
	]
};
var idToExternalAndNameMapping = {
	"5427": [
		"default",
		"./MenuBar",
		6137
	]
};
var idToRemoteMap = {
	"5427": [
		{
			"externalType": "script",
			"name": "menu",
			"externalModuleId": 6137
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}